import React from 'react';

export const HorizontalLineSep = () => {
        return (
            <div>
                <hr style={
                    {
                        color: '#E1E1E1', borderColor:
                            '#E1E1E1'
                    }
                }
                />
            </div>
        );
    };